import $ from 'jquery'
import bottleSlider from './bottleSlider'
import imagesSlider from './imagesSlider'
import { TweenMax } from 'gsap/gsap-core';

export default {
  init() {
    bottleSlider.init()
    imagesSlider.init()

    if (!IS_MOBILE) {
      $(window).on('scroll', this.setPackshotPosition)
      $(window).on('resize', this.setPackshotPosition)
      this.setPackshotPosition()
    }

    $('.singleWine__details-viewMore').on('click', function() {
      $('html, body').animate( { scrollTop: $('.singleWine__details-content').offset().top - 100 }, 500 )
			return false
    })

    // const offset = $('.singleWine__details').offset()
    // const packshotWidth = window.innerWidth - $('.singleWine__details').innerWidth() - offset.left
    // console.info(offset.left, packshotWidth)
    // $('.singleWine__packshot').width(packshotWidth)

    let sliderBottle = true

    $('.singleWine__packshot img').on('click', () => {
      TweenMax.to(['.singleWine__packshot-largeEtiquette', '.singleWine__packshot-thumbBottle'], .5, {
        autoAlpha: sliderBottle ? 0 : 1
      })

      TweenMax.to(['.singleWine__packshot-largeBottle', '.singleWine__packshot-thumbEtiquette'], .5, {
        autoAlpha: sliderBottle ? 1 : 0
      })

      sliderBottle = !sliderBottle
    })
  },
  setPackshotPosition() {
    const detailsTopPosition = $('.singleWine__details').offset().top
    const detailsHeight = $('.singleWine__details').innerHeight()
    const viewportHeight = $(window).innerHeight()

    if (window.scrollY > (detailsTopPosition + detailsHeight - viewportHeight)) {
      $('.singleWine__packshot').removeClass('singleWine__packshot--sticky')
    } else {
      $('.singleWine__packshot').addClass('singleWine__packshot--sticky')
    }

    const offset = $('.singleWine__details').offset()
    const packshotWidth = window.innerWidth - $('.singleWine__details').width() - offset.left
    console.info(packshotWidth)

    $('.singleWine__packshot').css('left', $('.singleWine__details').width() + offset.left)
    $('.singleWine__packshot').width(packshotWidth)
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
